// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, get, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { Cart, CartResult } from "@insite/client-framework/Services/CartService";
import { CartModel } from "@insite/client-framework/Types/ApiModels";

export interface SwapCartApiParameter extends ApiParameter {
    saveCurrent: boolean;
    cartLabel: string;
    cartToLoadId: string;
    forceRecalculation?: string;
}

const swapCartsUrl = "/api/custom/carts/SwapCart";

export const invalidAddressException = "Insite.Core.Exceptions.InvalidAddressException";

export async function swapCartWithResult(
    swapCartApiParameter: SwapCartApiParameter,
): Promise<ServiceResult<CartResult>> {
    try {
        const cartModel = await get<CartModel>(`${swapCartsUrl}`, swapCartApiParameter);
        const cartResult = {
            cart: cartModel as Cart,
            billTo: cartModel.billTo ? cartModel.billTo : undefined,
            shipTo: cartModel.shipTo ? cartModel.shipTo : undefined,
        };
        return {
            successful: true,
            result: cartResult,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
